export function isLastBreadcrumb(index: number, breadcrumbs: Array<any>){

  if (index + 1 === breadcrumbs.length) {
    return true;
  }

  return false;

}